import React from 'react'
import './styles.scss'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/label.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/header.css'
var linkifyHtml = require('linkifyjs/html');

import categories from '../categorybutton/categories.js'

function urlify(inputText) {
  var s = inputText.replace(/\n/g, '<br />' );
  return <span dangerouslySetInnerHTML={{__html: linkifyHtml(s, {defaultProtocol: 'https'})}} />
}

function Popup(props) {
  const cat = categories.find(c => c.ident === props.category)
  return (
    <div className='popup'>
      <div className='badge'>
        <span
          className='colorindicator'
          style={{ backgroundColor: cat.color }}
        />
        <span className='text'>{cat.text}</span>
      </div>
      <span className='clearfix' />

      <h2>Name</h2>
      {props.title}

      <h2>Beschreibung</h2>
      {urlify(props.description)}

      <h2>Kontakt</h2>
      {urlify(props.contact)}

      <h2>Adresse</h2>
      {props.street}<br />{props.place}
    </div>
  )
}

export default Popup
